module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1020-98ed3fb18698d30bff93632bd983d164.png";